import type { AppLocale } from "./dashboard-copy";

export const purchaseCopy = {
  en: {
    title: "Activate full access",
    subtitle: "Unlock your NOC code, remove the watermark, and download the clean HD PDF for 7 days.",
    priceLoading: "Loading price…",
    priceFallback: "$19.99",
    taxSuffix: "CAD",
    payWithStripe: "Pay with Stripe",
    redirecting: "Redirecting to Stripe…",
    whatsIncluded: "What full access includes",
    close: "Close",
    unavailable: "Something went wrong. Please try again.",
    noResume: "Create a resume before activating full access.",
  },
  fr: {
    title: "Activer l’accès complet",
    subtitle: "Déverrouillez votre code CNP, retirez le filigrane et téléchargez le PDF HD propre pendant 7 jours.",
    priceLoading: "Chargement du prix…",
    priceFallback: "19,99 $",
    taxSuffix: "CAD",
    payWithStripe: "Payer avec Stripe",
    redirecting: "Redirection vers Stripe…",
    whatsIncluded: "Ce que comprend l’accès complet",
    close: "Fermer",
    unavailable: "Une erreur est survenue. Veuillez réessayer.",
    noResume: "Créez un CV avant d’activer l’accès complet.",
  },
} as const satisfies Record<AppLocale, object>;
